// -------------- import external dependencies ------------
import React from "react";

// ------------ import external dependencies -----------
// styles
import { BtnStyle } from "./style";

interface ButtonProps {
  children?: React.ReactNode;
  textContent?: string;
  type?: "button" | "submit";
  loading?: boolean;
  variant?: "sm" | "md";
  addClass?: string;
  click?: (e: any) => void;
  disabled?: boolean;
  testid?: string;
}

function Button({
  children,
  textContent,
  type = "button",
  loading,
  variant = "sm",
  addClass,
  click,
  disabled,
  testid,
}: Readonly<ButtonProps>) {
  return (
    <BtnStyle
      data-testid={testid}
      type={type}
      disabled={loading ?? disabled}
      variant={variant}
      className={addClass}
      onClick={click}
    >
      {children ?? textContent}
    </BtnStyle>
  );
}

export default Button;
